Apt.fn.make('faq', {
	/**
	 * Initialize module
	 */
	init: function() {
		var hash = $._win.location.hash,
			expandedClass = '-is-expanded';

		$$('faq').on('click', function(e, el) {
			var $el = $(el).parent();

			if (! $el.hasClass(expandedClass)) {
				$.animate.tween($._body, {
					scrollTop: $el.offset().top
				});
			}

			$el.toggleClass(expandedClass);
		}, {
			cancel: true,
			namespace: 'faq'
		});

		if (hash) {
			var $faq = $('a[href="' + hash + '"]');

			if ($faq.length) {
				$faq.trigger('click');
			}
		}
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('faq');
	}
});